export default {
  GET_COUNTRY_LIST_REQUEST: "GET_COUNTRY_LIST_REQUEST",
  GET_COUNTRY_LIST_RESPONSE: "GET_COUNTRY_LIST_RESPONSE",
};
